import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuelidate from "vuelidate";
import VModal from "vue-js-modal";
import VueMoment from "vue-moment";
import moment from 'moment-timezone'
import { ToastPlugin } from "bootstrap-vue";
import IdleVue from "idle-vue";
import VueChatScroll from "vue-chat-scroll";
import Toasted from "vue-toasted";
import { ModalPlugin } from "bootstrap-vue";
import i18n from './locales/i18n';

Vue.config.productionTip = false;

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 60000,
});

const token = sessionStorage.getItem("token");
/*
const username = store.state.auth.user?.userName.toLowerCase();
const key = `deviceToken:${username}`;
const deviceToken =localStorage.getItem(key);
*/

if (token) {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + token;
}

/*
if(deviceToken){
 axiosInstance.defaults.headers.common["X-Trusted-Device"] = deviceToken;
}
*/
//*************** */
Vue.directive("disable-all", {
  inserted(el, binding) {
    applyDisable(el, binding.value);
  },
  update(el, binding) {
    applyDisable(el, binding.value);
  }
});

function applyDisable(el, value) {
  if (!value) return;

  const tags = ["input", "button", "textarea", "select", "span","div","p"];
  tags.forEach(tag => {
    const elements = el.getElementsByTagName(tag);

    if (elements.length === 0) {
      if (el.nodeName.toLowerCase() === tag) {
        el.disabled = value;
        el.tabIndex = value ? -1 : 0;

        if (tag === "span" || tag === "div") {
          el.addEventListener(
            "click",
            function (e) {
              e.stopImmediatePropagation();
              e.preventDefault();
            },
            true
          );
        }
      }
    } else {
      for (let i = 0; i < elements.length; i++) {
        elements[i].disabled = value;
        elements[i].tabIndex = value ? -1 : 0;

        if (tag === "span" || tag === "div") {
          elements[i].addEventListener(
            "click",
            function (e) {
              e.stopImmediatePropagation();
              e.preventDefault();
            },
            true
          );
        }
      }
    }
  });
}

//************** */

Vue.use(VueAxios, axiosInstance);
Vue.use(Vuelidate);
//Vue.use(VueMoment);
Vue.use(VueMoment, {
  moment,
});
Vue.use(VModal, { dialog: true });
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);
Vue.use(VueChatScroll);
Vue.use(Toasted, {
  iconPack: "fontawesome", // set your iconPack, defaults to material. material|fontawesome|custom-class
});
Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  events: ["keydown", "mousedown", "touchstart"],
  idleTime: 90 * 60 * 1000, // 1.5 HOUR
  startAtIdle: false,
  store,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
